import path from 'ramda/src/path';

export default {
  black: '#333A3D',
  red: '#ff7777',
  gray: '#889BA4',
  grey: '#889BA4',
  'gray-dark': '#4F4F4F',
  'gray-light': '#EEEEEE',
  teal: '#2ABEC7',
  white: '#FFFFFF',
  yellow: '#FFC44D',
  silver: '#ecf0f1',
  orange: '#ffc44d',
  fontFamily:
    "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif;",
};

export const colors = (color: string) => (props: any) => path(['theme', color], props);
